import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { element } from 'prop-types';
import path from 'path-browserify';

// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));
const OverviewEcommercePage = lazy(() => import('src/pages/dashboard/ecommerce'));
const OverviewAnalyticsPage = lazy(() => import('src/pages/dashboard/analytics'));
const OverviewBankingPage = lazy(() => import('src/pages/dashboard/banking'));
const OverviewBookingPage = lazy(() => import('src/pages/dashboard/booking'));
const OverviewFilePage = lazy(() => import('src/pages/dashboard/file'));
// PRODUCT
const ProductDetailsPage = lazy(() => import('src/pages/dashboard/product/details'));
const ProductListPage = lazy(() => import('src/pages/dashboard/product/list'));
const ProductCreatePage = lazy(() => import('src/pages/dashboard/product/new'));
const ProductEditPage = lazy(() => import('src/pages/dashboard/product/edit'));
// BANDEJA
const TrayListPage = lazy(() => import('src/pages/dashboard/tray/list'));
const TrayEntranceListPage = lazy(() => import('src/pages/dashboard/tray/entrance'));
const TrayEarringsListPage = lazy(() => import('src/pages/dashboard/tray/earrings'));
const TrayMisTramitesListPage = lazy(() => import('src/pages/dashboard/tray/misTramites'));
const TrayRegistrarTramitesListPage = lazy(() =>
  import('src/pages/dashboard/tray/registrar-tramite')
);
const TrayRegistrarHistoricoPage = lazy(() =>
  import('../../pages/dashboard/tray/registrarHistorico')
);

const TraySentListPage = lazy(() => import('src/pages/dashboard/tray/sent'));
const TrayRecibirDerivarListPage = lazy(() => import('src/pages/dashboard/tray/recibirderivar'));
const TrayRecibirListPage = lazy(() => import('src/pages/dashboard/tray/recibir'));
const TrayAgregarListPage = lazy(() => import('src/pages/dashboard/tray/agregar'));
// const TrayRecibirDerivarListPage = lazy(() => import('src/pages/dashboard/tray/recibiryderivar'));

// DOCUMENTOS
const DocumentosListPage = lazy(() => import('src/pages/dashboard/documentos/list'));
const TramitesUsuariosListPage = lazy(() => import('src/pages/dashboard/tramites-usuarios/list'));
// HOJA DE RUTA
const HojaDeRutaListPage = lazy(() => import('src/pages/dashboard/hoja-de-ruta/list'));
const HojaRutaListaUsuario = lazy(() => import('src/pages/dashboard/hoja-ruta-usuario/list'));
const ListadoHojaRutaPagina = lazy(() => import('src/pages/dashboard/hoja-ruta-usuario/listado'));

// SEGUIMIENTO DE TRAMITES USUARIO
const SeguimientoTramitePagina = lazy(() =>
  import('src/pages/dashboard/seguimiento-tramite/pagina')
);

// seguimiento listado de tramites
const ListadoSeguimientoPagina = lazy(() =>
  import('src/pages/dashboard/listado-seguimiento/listado')
);

// TRAMITES Y REQUESITOS
const TramitesRequisitosListPage = lazy(() =>
  import('src/pages/dashboard/tramitesrequisitos/list')
);

// PROCESOS DE NODOS
const ProcesosListPage = lazy(() => import('src/pages/dashboard/procesos/list'));
// TICKETS
const RegistrarTicket = lazy(() => import('src/pages/dashboard/tickets/registrar'));
const ListarTicket = lazy(() => import('src/pages/dashboard/tickets/listar'));
const Confirmar = lazy(() => import('src/pages/dashboard/tickets/confirmar'));

// area/departamentos
const AreaListPage = lazy(() => import('src/pages/dashboard/area/list'));
const NuevoListPage = lazy(() => import('src/pages/dashboard/area/new'));

// ORDER
const OrderListPage = lazy(() => import('src/pages/dashboard/order/list'));
const OrderDetailsPage = lazy(() => import('src/pages/dashboard/order/details'));
// INVOICE
const InvoiceListPage = lazy(() => import('src/pages/dashboard/invoice/list'));
const InvoiceDetailsPage = lazy(() => import('src/pages/dashboard/invoice/details'));
const InvoiceCreatePage = lazy(() => import('src/pages/dashboard/invoice/new'));
const InvoiceEditPage = lazy(() => import('src/pages/dashboard/invoice/edit'));
// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
const UserCardsPage = lazy(() => import('src/pages/dashboard/user/cards'));
const UserListPage = lazy(() => import('src/pages/dashboard/user/list'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/user/account'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/user/new'));
const UserEditPage = lazy(() => import('src/pages/dashboard/user/edit'));
// BLOG
const BlogPostsPage = lazy(() => import('src/pages/dashboard/post/list'));
const BlogPostPage = lazy(() => import('src/pages/dashboard/post/details'));
const BlogNewPostPage = lazy(() => import('src/pages/dashboard/post/new'));
const BlogEditPostPage = lazy(() => import('src/pages/dashboard/post/edit'));

// JOB
const JobDetailsPage = lazy(() => import('src/pages/dashboard/job/details'));
const JobListPage = lazy(() => import('src/pages/dashboard/job/list'));
const JobCreatePage = lazy(() => import('src/pages/dashboard/job/new'));
const JobEditPage = lazy(() => import('src/pages/dashboard/job/edit'));

// TOUR
const TourDetailsPage = lazy(() => import('src/pages/dashboard/tour/details'));
const TourListPage = lazy(() => import('src/pages/dashboard/tour/list'));
const TourCreatePage = lazy(() => import('src/pages/dashboard/tour/new'));
const TourEditPage = lazy(() => import('src/pages/dashboard/tour/edit'));
// FILE MANAGER
const FileManagerPage = lazy(() => import('src/pages/dashboard/file-manager'));
// APP
const ChatPage = lazy(() => import('src/pages/dashboard/chat'));
const MailPage = lazy(() => import('src/pages/dashboard/mail'));
const CalendarPage = lazy(() => import('src/pages/dashboard/calendar'));
const KanbanPage = lazy(() => import('src/pages/dashboard/kanban'));
// TEST RENDER PAGE BY ROLE
const PermissionDeniedPage = lazy(() => import('src/pages/dashboard/permission'));
// BLANK PAGE
const BlankPage = lazy(() => import('src/pages/dashboard/blank'));

const NuevaHojaRutaPagina = lazy(() => import('src/pages/dashboard/hoja-de-ruta/nuevaHojaRuta'));

// ----------------------------------------------------------------------

// esto es por dentro del sistema es decir por administrador

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'ecommerce', element: <OverviewEcommercePage /> },
      { path: 'analytics', element: <OverviewAnalyticsPage /> },
      { path: 'banking', element: <OverviewBankingPage /> },
      { path: 'booking', element: <OverviewBookingPage /> },
      { path: 'file', element: <OverviewFilePage /> },
      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          { path: 'cards', element: <UserCardsPage /> },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
          { path: ':id/edit', element: <UserEditPage /> },
          { path: 'account', element: <UserAccountPage /> },
        ],
      },
      {
        path: 'product',
        children: [
          { element: <ProductListPage />, index: true },
          { path: 'list', element: <ProductListPage /> },
          { path: ':id', element: <ProductDetailsPage /> },
          { path: 'new', element: <ProductCreatePage /> },
          { path: ':id/edit', element: <ProductEditPage /> },
        ],
      },

      // bandeja o tray
      // esto hace que se muetren las dataTables de los productos
      {
        path: 'tray',
        children: [
          { element: <TrayListPage />, index: true },
          { path: 'list', element: <TrayListPage /> },
          { path: 'entrance', element: <TrayEntranceListPage /> },
          { path: 'earrings', element: <TrayEarringsListPage /> },
          { path: 'mis_tramites', element: <TrayMisTramitesListPage /> },
          { path: 'registrar', element: <TrayRegistrarTramitesListPage /> },
          { path: 'registrar-historico', element: <TrayRegistrarHistoricoPage /> },
          { path: 'sent', element: <TraySentListPage /> },
          { path: 'recibirderivar', element: <TrayRecibirDerivarListPage /> },
          { path: 'recibir', element: <TrayRecibirListPage /> },
          { path: 'agregar', element: <TrayAgregarListPage /> },
          // { path: 'recibir', element: <TrayRecibirDerivarListPage /> },
        ],
      },
      {
        path: 'documentos',
        children: [
          { element: <DocumentosListPage />, index: true },
          { path: 'list', element: <DocumentosListPage /> },
        ],
      },
      {
        path: 'tramites_usuarios',
        children: [
          { element: <TramitesUsuariosListPage />, index: true },
          { path: 'list', element: <TramitesUsuariosListPage /> },
        ],
      },

      // hoja de ruta
      {
        path: 'hoja_de_ruta',
        children: [
          { element: <HojaDeRutaListPage />, index: true },
          { path: 'list', element: <HojaDeRutaListPage /> },
        ],
      },
      // Hoja de ruta usuarios
      {
        path: 'hoja_de_ruta_usuario',
        children: [
          { element: <HojaRutaListaUsuario />, index: true },
          { path: 'list', element: <HojaRutaListaUsuario /> },
          { path: 'listado', element: <ListadoHojaRutaPagina /> },
        ],
      },
      // seguimiento de tramites usuario
      {
        path: 'seguimiento-tramites',
        children: [
          { element: <SeguimientoTramitePagina />, index: true },
          { path: 'pagina', element: <SeguimientoTramitePagina /> },
          { path: 'listado', element: <ListadoSeguimientoPagina /> },
        ],
      },
      // tramites y requisitos
      {
        path: 'tramitesrequisitos',
        children: [
          { element: <TramitesRequisitosListPage />, index: true },
          { path: 'list', element: <TramitesRequisitosListPage /> },
        ],
      },
      // precesos de nodos
      {
        path: 'procesos',
        children: [
          { element: <ProcesosListPage />, index: true },
          { path: 'list', element: <ProcesosListPage />, index: true },
        ],
      },
      // tickets
      {
        path: 'tickets',
        children: [
          { element: <RegistrarTicket />, index: true },
          { path: 'listar', element: <ListarTicket /> },
          { path: 'confirmar', element: <Confirmar /> },
        ],
      },

      {
        path: 'area',
        children: [
          { element: <AreaListPage />, index: true },
          { path: 'list', element: <AreaListPage /> },
          { path: 'new', element: <NuevoListPage /> },
        ],
      },

      {
        path: 'order',
        children: [
          { element: <OrderListPage />, index: true },
          { path: 'list', element: <OrderListPage /> },
          { path: ':id', element: <OrderDetailsPage /> },
        ],
      },
      {
        path: 'invoice',
        children: [
          { element: <InvoiceListPage />, index: true },
          { path: 'list', element: <InvoiceListPage /> },
          { path: ':id', element: <InvoiceDetailsPage /> },
          { path: ':id/edit', element: <InvoiceEditPage /> },
          { path: 'new', element: <InvoiceCreatePage /> },
        ],
      },
      {
        path: 'post',
        children: [
          { element: <BlogPostsPage />, index: true },
          { path: 'list', element: <BlogPostsPage /> },
          { path: ':title', element: <BlogPostPage /> },
          { path: ':title/edit', element: <BlogEditPostPage /> },
          { path: 'new', element: <BlogNewPostPage /> },
        ],
      },
      {
        path: 'job',
        children: [
          { element: <JobListPage />, index: true },
          { path: 'list', element: <JobListPage /> },
          { path: ':id', element: <JobDetailsPage /> },
          { path: 'new', element: <JobCreatePage /> },
          { path: ':id/edit', element: <JobEditPage /> },
        ],
      },
      // {
      //   path: 'legalizaciones',
      //   children: [
      //     { element: <LegalizacionesCreatePage />, index: true },
      //     { path: 'new', element: <LegalizacionesCreatePage /> },
      //   ],
      // },
      {
        path: 'tour',
        children: [
          { element: <TourListPage />, index: true },
          { path: 'list', element: <TourListPage /> },
          { path: ':id', element: <TourDetailsPage /> },
          { path: 'new', element: <TourCreatePage /> },
          { path: ':id/edit', element: <TourEditPage /> },
        ],
      },
      { path: 'file-manager', element: <FileManagerPage /> },
      { path: 'mail', element: <MailPage /> },
      { path: 'chat', element: <ChatPage /> },
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'kanban', element: <KanbanPage /> },
      { path: 'permission', element: <PermissionDeniedPage /> },
      { path: 'blank', element: <BlankPage /> },

      // refactorizando codigo
      { path: 'nuevo', element: <NuevaHojaRutaPagina />, index: true },
      // nos quedamos aqui en neuvahojarutapagina
    ],
  },
];
